export default "__VITE_ASSET__324eca6a__$_?nuxt_component=async__"